export const APP_NAME = '1lalana';
export const AUTHOR_USERNAME = 'tiavina-mika';
export const APP_SHORT_NAME = 'Mika';

export const collections = {
  Article: 'Article',
  Newsletter: 'Newsletter',
  Page: 'Page',
  Category: 'Category',
  Contact: 'Contact',
  App: 'App',
  Ride: 'Ride',
  Request: 'Request',
  Notification: 'Notification',
};

export const DISABLE_USER_ACCOUNT_CONFIRMATION = false;
export const PAGINATION = {
  perPage: 12,
};

export const COOKIES = {
  locale: 'NEXT_LOCALE',
};

export const IMAGES = {
  logo: '/images/logo.svg',
  technologies: '/images/brain.webp',
};

export const SOCIALS = [
  {
    label: 'linkedin',
    value: 'https://www.linkedin.com/in/tiavina-michael-ralainirina/',
  },
  { label: 'instagram', value: 'https://www.instagram.com/sanzenmysteriu/' },
  { label: 'youtube', value: 'https://www.youtube.com/@tiavina-mika' },
];

export const EMAIL = 'tiavinamika@gmail.com';

export const CONTACTS = [
  'VN 50B, Ambohitsoa',
  'Antananarivo, Madagascar',
  EMAIL,
];

export const FOOTER = {
  description:
    'La confiance en soi s\'acquiert par l\'expérience et le travail acharné.',
  menus: [
    { label: 'Contact', value: '/' },
    { label: 'Mes projets', value: '/' },
    { label: 'Plan du site', value: '/' },
    { label: 'Politique de confidentialité', value: '/' },
  ],
};

export const LINKS = {
  downloadGooglePlay: '/',
  downloadAppStore: '/',
};
